export const checksums = {
  "blogs": "v3.5.0--RYXodVQzUYYdDzVef9WnqZ52Ez1cYNtEBizu6VL7l7w",
  "industries": "v3.5.0--it0tWVkcTXuvlnR-ec-olyAFYeUXe10w3FLrUXuFp8U",
  "products": "v3.5.0--lwxJOjsiXECvo9vmGkzwX7fD0Ex_g-ZsW8rlEYD60tM",
  "applications": "v3.5.0--hz3f2h1BQHyjIM6ZrUKWazqcX3iByXv-44hnclwGp7g"
}
export const checksumsStructure = {
  "blogs": "E7A_Chm8u67K0-yVJTH_h7tB9WtKighZugHpALDd4Ek",
  "industries": "SFAh1HDCiQCt3jazZiHCOwXJuYJQgQ7_3XZq3mQnHjA",
  "products": "Jh2TvjXo5QEK4ya9lK1wxshRqTB8ZoiGhS09WABh5SI",
  "applications": "Nn0lDzaThLLZ1DRGh1YnN4J0kyx2KJ2Iu-X0Rq5RX8E"
}

export const tables = {
  "blogs": "_content_blogs",
  "industries": "_content_industries",
  "products": "_content_products",
  "applications": "_content_applications",
  "info": "_content_info"
}

export default {
  "blogs": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "slug": "string",
      "active": "boolean",
      "date": "string",
      "author": "string",
      "category": "string",
      "tags": "json",
      "excerpt": "string",
      "image": "string",
      "cardImgObjPosition": "string",
      "hero": "json"
    }
  },
  "industries": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "slug": "string",
      "hero": "json"
    }
  },
  "products": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "json",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "slug": "string",
      "active": "boolean",
      "featured": "boolean",
      "titles": "json",
      "code": "string",
      "purity": "string",
      "origin": "string",
      "denaturation": "string",
      "category": "string",
      "subCategory": "string",
      "image": "string",
      "images": "json",
      "msds": "string",
      "hero": "json",
      "sizes": "json",
      "ingredients": "json",
      "labels": "json",
      "cardcontent": "json",
      "cards": "json",
      "applications": "json",
      "industries": "json"
    }
  },
  "applications": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "slug": "string",
      "hero": "json",
      "introHairline": "string",
      "introPrimaryTitle": "string",
      "introDescription": "string",
      "introCTA": "string",
      "challenges": "json",
      "statementTitle": "string",
      "statementContent": "string",
      "solutionsHairline": "string",
      "solutionsTitle": "string",
      "solutionsDescription": "string",
      "solutions": "json",
      "sphereHairline": "string",
      "sphereTitle": "string",
      "sphereDescription": "string",
      "spheres": "json",
      "industryStatementHairline": "string",
      "industryStatementSolution": "string",
      "contactHairline": "string",
      "contactTitle": "string",
      "contactDescription": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}